import { ListJobsResponseSchema, type ListJobsResponse } from '@vy/api-definition';
import { PERMISSIONS } from '@vy/types';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import { hasPermissions } from '../../services/render-with-permissions';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useJobs(options?: CustomUseQueryOptions<ListJobsResponse>) {
  // Prevents Viewer role from 403 on this endpoint.
  const canReadJobs = hasPermissions([PERMISSIONS.JOB_FULL_ACCESS]);

  return useQuery(
    queryKeys.jobs(),
    async () => {
      const api = getPrivateApi();
      const listJobsResponse = await api.listJobs();

      return ListJobsResponseSchema.parse(listJobsResponse);
    },
    {
      ...options,
      enabled: canReadJobs && (options?.enabled ?? true),
    },
  );
}
